import { render, staticRenderFns } from "./AlertScanFailureApplyDiscount.vue?vue&type=template&id=707cf3bf&scoped=true&"
import script from "./AlertScanFailureApplyDiscount.vue?vue&type=script&lang=ts&"
export * from "./AlertScanFailureApplyDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AlertScanFailureApplyDiscount.vue?vue&type=style&index=0&id=707cf3bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cf3bf",
  null
  
)

export default component.exports